import jApi from './jApi';

export default {
  // Widget
  getTimesheetDetail(req) {
    const api = jApi.generateApi();
    return api.post('/times/timesheet/task/list-by-date', req)
      .then(res => res.data);
  },

  getOrganigramId(req) {
    const api = jApi.generateApi();
    return api.post('/jojoflow/organigram/detail-by-user-company', req)
      .then(res => res.data);
  },

  getQuotaLeave(req) {
    const api = jApi.generateApi();
    return api.post('/times/leave-config/type/list', req)
      .then(res => res.data);
  },

  getAttendanceDetail() {
    const api = jApi.generateApi();
    return api.get('/times/attendances/check-attendance')
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiHome.js